import type { HelpFile } from '../../types/help'
import { LifecycleEventsTestIds } from '../../../testids/LifecycleEventsTestIds'

export const lifecycleEventsHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [LifecycleEventsTestIds.lifecycleEventsList]:
      'Cross-cutting timeline of every identity and account state change — filter, sort, and paginate to investigate transitions for compliance reporting.',
    [LifecycleEventsTestIds.lifecycleEventsLoading]: null,
    [LifecycleEventsTestIds.lifecycleEventsEmpty]:
      'No lifecycle events match the current filters. Use Clear filters to reset.',
    [LifecycleEventsTestIds.colChangedAt]:
      'When the transition was recorded — backed by the changed_at column on identity_lifecycle_events / account_status_events.',
    [LifecycleEventsTestIds.colEntity]:
      'Entity discriminator — IDENTITY or ACCOUNT — and a link to the affected entity.',
    [LifecycleEventsTestIds.colFromTo]:
      'Previous and new state. Creation rows show "Created · <toState>" because they have no fromState.',
    [LifecycleEventsTestIds.colTriggerSource]:
      'Which business process drove the change (USER_ACTION, JML_LEAVER, EXIT_DATE_JOB, etc.).',
    [LifecycleEventsTestIds.colActor]:
      'The human actor who performed the change. System-driven transitions show a "System" pill with the trigger source.',
    [LifecycleEventsTestIds.colReason]:
      'Free-text reason captured at transition time. Truncated at 60 chars; hover to see the full text.',
  },
}
